import { render, staticRenderFns } from "./Publications.vue?vue&type=template&id=0d94a5d7&scoped=true&"
import script from "./Publications.vue?vue&type=script&lang=js&"
export * from "./Publications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d94a5d7",
  null
  
)

export default component.exports